import { AxiosError } from "axios";

import { ICustomerTemplateInput } from "@/interfaces/customer-template.interface";
import { apiT2B } from "@/lib/axios";

const baseUrl = "/api/v1/CustomerTemplate";

export async function updateCustomerTemplate(
  id: number,
  input: ICustomerTemplateInput
): Promise<void> {
  try {
    await apiT2B.put(`${baseUrl}/${id}`, {
      text: input.text,
      messageTemplate: input.messageTemplate,
      notificationOn: input.notificationOn,
    });
  } catch (error) {
    if (error instanceof AxiosError) {
      throw new Error(error.response?.data?.message || "Falha ao salvar o template");
    }

    throw new Error("Falha ao salvar o template");
  }
}
